import { useGetPartnerQuery } from '@/api/api.slice.tsx';
import { ReactNode } from 'react';
import { Navigate } from 'react-router';

const VALID_ONBOARDING_SIGN_UP_STATUS = ['to-migrate-invited', 'invited'];

/**
 * Use to wrap Onboarding components and check if the token is valid
 *
 * @param props          props of the component
 * @param props.children children prop
 *
 * @returns              JSX of the component
 */
export const CheckSignUpStatusForOnboarding = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  const { data: me } = useGetPartnerQuery();

  if (me && !VALID_ONBOARDING_SIGN_UP_STATUS.includes(me.signUpStatus)) {
    return <Navigate to='/' />;
  }

  return <>{children}</>;
};
